import api from '../services/api';

export const getServiceHealthIpp = async (url?: string, token?: string) => {
  try {
    const response = await api.get(`${url}`, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8;application/x-www-form-urlencoded',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.status === 200;
  } catch (error) {
    return false;
  }
};
